import React, { useState, useRef, useEffect } from 'react';
import api from '../config/api';
import Turnstile from 'react-turnstile';
import './ContactUsPage.css';

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    feedbackType: '',
    feedback: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const dropdownRef = useRef(null);

  const feedbackTypes = [
    'General Inquiry',
    'Complaint',
    'Suggestion',
    'Technical Issue',
    'Booking Issue',
    'Refund Request',
    'Other',
  ];

  const whatsappNumber = "918086876577";

  const message = "Hi, I have an enquiry regarding movie bookings.";

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  // Custom dropdown handlers
  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleOptionSelect = (value) => {
    setFormData(prev => ({
      ...prev,
      feedbackType: value,
    }));
    setDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate Turnstile token
    if (!turnstileToken) {
      setSubmitStatus({ type: 'error', message: 'Please complete the verification challenge.' });
      return;
    }
    
    setSubmitting(true);
    setSubmitStatus(null);

    try {
      const data = await api.submitContact({
        ...formData,
        turnstileToken
      });
      
      setSubmitStatus({ type: 'success', message: data.message || 'Thank you! Your feedback has been submitted successfully.' });
      setFormData({
        name: '',
        mobile: '',
        email: '',
        feedbackType: '',
        feedback: '',
      });
      setTurnstileToken(null);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setSubmitStatus({ type: 'error', message: error.message || 'An error occurred. Please try again later.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-us-page">
      <div className="contact-container">
        <div className="contact-form-section">
          <h1>Contact Us</h1>
          <form onSubmit={handleSubmit} className="contact-form" autoComplete="off">
            <div className="form-row">



              <div className="form-group">
              <label htmlFor="name">Name <span className="required">*</span></label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  autoComplete="off"
                />
              </div>
              <div className="form-group">
                
<label htmlFor="mobile">Mobile No. <span className="required">*</span></label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                  autoComplete="off"
                />
              </div>
            </div>




            <div className="form-row">
  <div className="form-group">
    <label htmlFor="email">Email ID <span className="required">*</span></label>
    <input
      type="email"
      id="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      required
      autoComplete="off"
    />
  </div>

  <div className="form-group">
    <label htmlFor="feedbackType">Feedback Type <span className="required">*</span></label>
    <div className="custom-dropdown" ref={dropdownRef}>
      <div 
        className={`custom-dropdown-trigger ${dropdownOpen ? 'open' : ''}`}
        onClick={handleDropdownToggle}
      >
        {formData.feedbackType || 'Select Feedback Type'}
        <span className="dropdown-arrow"></span>
      </div>
      {dropdownOpen && (
        <div className="custom-dropdown-options">
          {feedbackTypes.map((type) => (
            <div
              key={type}
              className="custom-dropdown-option"
              onClick={() => handleOptionSelect(type)}
            >
              {type}
            </div>
          ))}
        </div>
      )}
    </div>
    <input
      type="hidden"
      name="feedbackType"
      value={formData.feedbackType}
      required
    />
  </div>
</div>







            <div className="form-group">
            <label htmlFor="feedback">Write Feedback <span className="required">*</span></label>

              <textarea
                id="feedback"
                name="feedback"
                value={formData.feedback}
                onChange={handleChange}
                rows="6"
                required
                autoComplete="off"
              />
            </div>

            <div className="form-group">
              <label>Verification <span className="required">*</span></label>
              <div className="turnstile-container">
                <Turnstile
                  sitekey="0x4AAAAAAChQFz4JncyidFQp"
                  onVerify={(token) => setTurnstileToken(token)}
                  onExpire={() => setTurnstileToken(null)}
                  onError={() => setTurnstileToken(null)}
                />
              </div>
            </div>

            <div className="form-footer">
              <div className="contact-info-inline">
                <div className="contact-item-inline">
                  <i className="fas fa-phone"></i>
                  <span>+91 8086876577</span>
                </div>
                <div className="contact-item-inline">
                  <i className="fas fa-envelope"></i>
                  <span>support@mycinemas.in</span>
                </div>
              </div>
              <button type="submit" className="primary-btn" disabled={submitting || !turnstileToken}>
                {submitting ? 'Submitting...' : 'Submit Request'}
              </button>
            </div>

            {submitStatus && (
              <div className={`submit-status ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}
          </form>
        </div>

        <div className="contact-info-section">
          <h2>You may directly reach out to us</h2>


          <div className="contact-info-box company-legal-box">
  <h3 className="company-legal-title">Company & GST Details</h3>

  <div className="company-legal-item">
    <span className="legal-label">Legal Name:</span>
    <span className="legal-value">AARVJ GROUP PRIVATE LIMITED</span>
  </div>

  <div className="company-legal-item">
    <span className="legal-label">GSTIN:</span>
    <span className="legal-value">32AAPCA1202Q1ZP</span>
  </div>

  <div className="company-legal-item">
    <span className="legal-label">Registered Address:</span>
    <span className="legal-value">
      3rd Floor, 60/49E, JC Chambers,<br />
      Panampilly Nagar Road, Opp. Kairali Apartments,<br />
      Panampilly Nagar, Kochi,<br />
      Ernakulam, Kerala – 682036
    </span>
  </div>
</div>




          
          <div className="contact-info-box">
            <div className="contact-info-item">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="contact-details">
                <span className="contact-label">Email:</span>
                <span className="contact-value">support@mycinemas.in</span>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <div className="contact-details">
                <span className="contact-label">Phone No.:</span>
                <span className="contact-value">+91 8086876577</span>
                <span className="contact-timing">9AM to 10PM, Mon-Sun</span>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon whatsapp-icon">
                <i className="fab fa-whatsapp"></i>
              </div>
              <div className="contact-details">
                <span className="contact-label">WhatsApp:</span>
                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-value"
                >
                  +91 8086876577
                </a>
                <span className="contact-timing">9AM to 7PM, Mon-Sun</span>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="contact-details">
                <span className="contact-label">Contact Centre Timings:</span>
                <span className="contact-value">9AM to 10PM, Mon-Sun</span>
                
              </div>
            </div>
          </div>

         


          
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;

